import React from "react";
import { HStack, Progress, useColorModeValue } from "@chakra-ui/react";

type TutorialProgressProps = {
  tasks: string[];
  completedTasks: string[];
  showNoProgress?: boolean;
};

export function TutorialProgress({
  tasks,
  completedTasks,
  showNoProgress,
}: TutorialProgressProps) {
  const progress =
    tasks.length &&
    tasks.filter((task) => completedTasks.includes(task)).length / tasks.length;
  const progressBg = useColorModeValue("gray.300", "whiteAlpha.200");

  if (!progress && !showNoProgress) {
    return null;
  }

  return (
    <HStack fontFamily="mono" fontWeight="semibold" fontSize="sm">
      <Progress
        w="16"
        colorScheme="green"
        size="xs"
        rounded="full"
        value={progress}
        max={1}
        bg={progressBg}
      />
      <span>{Math.round(progress * 100)}%</span>
    </HStack>
  );
}
